import { useState } from 'react'
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import api from '../services/api'
import { useConfirm } from './ConfirmProvider'

export default function AIPlanningPanel({ weekVan }) {
  const [details, setDetails] = useState(false)
  const [applied, setApplied] = useState(false)
  const confirm = useConfirm()
  const qc = useQueryClient()
  const wp = weekVan || new Date().toISOString().split('T')[0]

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['ai-plan', wp],
    queryFn: () => api.get('/ai-planning/optimaliseer', { params: { week_van: wp } }).then(r => r.data),
    enabled: false,
  })

  const applyMut = useMutation({
    mutationFn: () => api.post('/ai-planning/pas-toe', null, { params: { week_van: wp, bevestigd: true } }),
    onSuccess: (r) => { setApplied(true); qc.invalidateQueries(['planning']); alert(`✅ ${r.data.aangemaakte_slots} slots aangemaakt!`) },
    onError: (e) => alert('Fout: ' + (e.response?.data?.detail || e.message)),
  })

  return (
    <div className="border-2 border-[#1A3A5C] rounded-xl p-5 bg-gray-50">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <h4 className="font-bold text-[#1A3A5C] m-0 flex items-center gap-2">🤖 AI Planningsoptimalisatie</h4>
        <button onClick={() => refetch()} disabled={isLoading} className="px-4 py-1.5 bg-[#1A3A5C] text-white rounded-lg text-sm border-0 cursor-pointer disabled:opacity-50">
          {isLoading ? '⏳ Berekenen...' : '🔄 Analyseer week'}
        </button>
      </div>
      {!data && !isLoading && <p className="text-gray-500 text-sm m-0">Klik 'Analyseer week' voor optimale productievolgorde.</p>}
      {data && (
        <div>
          <div className="grid grid-cols-3 gap-2 mb-4">
            {[['Orders', data.orders?.length || 0, '#1A3A5C'], ['Machines', data.machine_bezetting?.length || 0, '#2D6A4F'], ['Winst', `${data.optimalisatie_winst_pct}%`, '#0B6E5E']].map(([l, v, c]) => (
              <div key={l} className="bg-white rounded-lg p-3 text-center border"><div className="text-lg font-bold" style={{ color: c }}>{v}</div><div className="text-xs text-gray-500">{l}</div></div>
            ))}
          </div>
          {data.machine_bezetting?.map((m, i) => (
            <div key={i} className="mb-2">
              <div className="flex justify-between text-xs mb-0.5"><span>{m.machine_naam || m.machine_id}</span><span className="font-bold" style={{ color: m.bezetting_pct > 80 ? '#B02020' : m.bezetting_pct > 60 ? '#E8830A' : '#2D6A4F' }}>{m.bezetting_pct.toFixed(0)}%</span></div>
              <div className="h-2 bg-gray-200 rounded-full overflow-hidden"><div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(m.bezetting_pct, 100)}%`, background: m.bezetting_pct > 80 ? '#B02020' : m.bezetting_pct > 60 ? '#E8830A' : '#2D6A4F' }} /></div>
            </div>
          ))}
          <button onClick={() => setDetails(!details)} className="text-xs text-[#1A3A5C] underline cursor-pointer border-0 bg-transparent p-0 mt-2 mb-2">{details ? '▲ Verberg' : '▼ Toon orders'}</button>
          {details && (data.orders || []).map((o, i) => (
            <div key={o.order_id} className="flex justify-between items-center py-2 border-b border-gray-200 text-sm">
              <div><span className="font-bold text-[#1A3A5C] mr-2">#{i + 1}</span>{o.order_nummer || o.order_id}</div>
              <div className="text-right text-xs"><div className="font-bold" style={{ color: o.reden?.includes('URGENT') ? '#B02020' : '#2D6A4F' }}>{o.reden}</div><div className="text-gray-400">→ {o.aanbevolen_machine} · {o.geschatte_uren}u</div></div>
            </div>
          ))}
          {!applied ? (
            <button onClick={async () => { if (await confirm({ message: 'AI planning toepassen?' })) applyMut.mutate() }} disabled={applyMut.isPending || !data.orders?.length}
              className="w-full py-2.5 mt-3 bg-green-700 text-white rounded-lg font-bold text-sm border-0 cursor-pointer disabled:opacity-50">
              {applyMut.isPending ? '⏳ Toepassen...' : `✅ Pas toe (${data.orders?.length || 0} orders)`}
            </button>
          ) : <div className="py-2.5 mt-3 bg-green-50 text-green-700 rounded-lg text-center font-bold text-sm">✅ Planning toegepast!</div>}
        </div>
      )}
    </div>
  )
}
